// =============================================================================
// Quote-review (maker-checker) shared helpers — role gate + status metadata.
//
// The approver set mirrors the backend's QuoteReviewController.IsApprover:
// the dedicated "CustomerService" role plus every admin-equivalent Epicor
// RoleCode (Admin / admin / Shukla / Testers / USAHedRep). Keep these in sync.
// =============================================================================
import { getUser } from "./auth";

const ADMIN_ROLECODES = ["admin", "shukla", "it", "testers", "usahedrep"];

/** True when the logged-in user may approve / return / create-now a conversion. */
export function isReviewApprover() {
  const role = (getUser().role || "").trim().toLowerCase();
  return role === "customerservice" || ADMIN_ROLECODES.includes(role);
}

// Status → friendly label + color "kind" (mirrors QuoteReviewMapper.Describe).
export const REVIEW_STATUS_META = {
  PendingReview:    { label: "In Review",         kind: "info",     stage: 2 },
  ChangesRequested: { label: "Returned to Rep",   kind: "warning",  stage: 2 },
  Approved:         { label: "Approved — Queued", kind: "info",     stage: 3 },
  Creating:         { label: "Creating Order…",   kind: "progress", stage: 4 },
  OrderCreated:     { label: "Order Created",     kind: "success",  stage: 5 },
  CreationFailed:   { label: "Needs Attention",   kind: "error",    stage: 4 },
};

// An approved MULTI-SHIP plan (terms M?K) is not queued for one order: its deliveries convert
// one purchase order at a time (SAL-GAP-64), so it gets its own label.
const MSP_TERMS = /^M[0-9A-Z]K$/i;

export function reviewStatusMeta(status, termsCode) {
  if (status === "Approved" && MSP_TERMS.test((termsCode || "").trim()))
    return { label: "Plan Approved — Converts by Delivery", kind: "info", stage: 3 };
  return REVIEW_STATUS_META[status] || { label: status || "Unknown", kind: "info", stage: 0 };
}

/** statusKind → an accent color (matches the convert modal's status tracker). */
export function statusColor(kind) {
  return { info: "#0052A5", progress: "#6366F1", success: "#10B981", warning: "#B45309", error: "#DC2626" }[kind] || "#64748B";
}

/** A react-bootstrap Badge bg for a systemCheck value. */
export function systemCheckBg(sc) {
  return sc === "Ready" ? "success" : sc === "Hold" ? "warning" : sc === "NotReady" ? "danger" : "secondary";
}
